<template>
  <div id="app" class="app">
    <!-- <auth-layout v-if="!$auth.check()"></auth-layout>
    <layout v-else></layout> -->
    <!-- <layout></layout> -->
    <router-view></router-view>
  </div>
</template>
<script>
  import Layout from './components/layout/layout'
  import AuthLayout from './components/layout/AuthLayout'

  export default {
    name: 'app',
    components: {
      AuthLayout,
      Layout
    },
    computed: {
      isAuth () {
        return this.$route.path.match('auth')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/App.vue